"use client";

import { FC } from "react";
import { FloatingActionButton } from "@aph/ui-lib-humanx";
import { useRouter } from "next/navigation";
import { isBrowser } from "@/helpers/isBrowser";
import styles from "./index.module.scss";

interface ApolloFabProps {
  fabData: {
    leadingImage?: string;
    title?: string;
    redirectionLink?: string;
  };
  isMobile: boolean;
}

const ApolloFab: FC<ApolloFabProps> = ({ fabData, isMobile }) => {
  const router = useRouter();

  const { leadingImage = "", title = "", redirectionLink = "" } = fabData || {};

  const handleClick = () => {
    if (!isBrowser() || !redirectionLink) return;
    const isExternalUrl = redirectionLink.startsWith("http://") || redirectionLink.startsWith("https://");

    if (isExternalUrl) {
      window.location.href = redirectionLink;
    } else {
      router.push(redirectionLink);
    }
  };

  return (
    <>
      {isMobile && (
        <div className={styles.fabContainer}>
          <FloatingActionButton leadingImage={leadingImage} title={title} onClick={handleClick} />
        </div>
      )}
    </>
  );
};

export default ApolloFab;
